export const environmentApi = {
  accessControl: {
    locations: 'access-control/locations',
    settings: 'access-control/settings',
    units: 'access-control/units/{location}',
    update: 'access-control/update',
    users: 'access-control/users?location={location}&groupId={groupId}&filter={filter}'
  },
  account: {
    updateUser: 'account/update-user'
  },
  admin: {
    deactivationCheck: 'admin/users/deactivation-check/{userId}',
    defaultUserLocations: 'admin/user-locations',
    locations: 'admin/locations',
    reassign: 'admin/users/reassign',
    securityGroups: 'admin/security-groups',
    users: 'admin/users',
    updateUserActiveStatus: 'web-users/active-status'
  },
  amenities: {
    get: 'amenities/location/{location}/unit/{unit}',
    getByMeeting: 'amenities/id/{id}',
    update: 'amenities/update/{scid}'
  },
  announcements: {
    get: 'announcements/type/{type}',
    base: 'announcements',
    delete: 'announcements/{id}'
  },
  auth: {
    refresh: 'account/refresh'
  },
  authToken: {
    get: 'auth-token'
  },
  callData: {
    getProfiles: 'call-data/profiles',
    deleteProfile: 'call-data/profiles/{id}',
    saveProfile: 'call-data/profiles',
    profileHasUploads: 'call-data/proflie/{id}/has-uploads',
    getHistory: 'call-data/history',
    deleteHistory: 'call-data/history/{id}',
    assignReject: 'call-data/assign-reject',
    getRejects: 'call-data/rejects/{historyId}',
    uploadFile: 'call-data/upload/{profileId}/location/{location}'
  },
  category: {
    get: 'category/{includeAll}'
  },
  checkIn: {
    checkIn: 'check-in',
    getByLocation: 'check-in/location/{location}'
  },
  client: {
    accountInfo: {
      deposits: 'client/account-info/deposits/location/{location}/tenant-id/{tenantId}',
      invoices: 'client/account-info/invoices/location/{location}/tenant-id/{tenantId}',
      openItems: 'client/account-info/open-items/location/{location}/tenant-id/{tenantId}',
      payments: 'client/account-info/payments/location/{location}/tenant-id/{tenantId}',
      retainer: 'client/account-info/retainer/location/{location}/tenant-id/{tenantId}',
      summary: 'client/account-info/summary/location/{location}/tenant-id/{tenantId}',
      transactionCodes: 'client/account-info/transaction-codes',
      addTransaction: 'client/account-info/transactions',
      applyTransaction: 'client/account-info/transactions/apply',
      returnedCheck: 'client/account-info/returned-check',
      correctMisappliedPayment: 'client/account-info/misapplied-payment',
      recentPayments: 'client/account-info/transactions/recent/location/{location}/tenant-id/{tenantId}'
    },
    agreement: {
      base: 'client/agreement',
      escalationOptions: 'client/agreement/escalation-options/location/{location}/tenant-id/{tenantId}',
      files: 'client/agreement/{id}/files/tenant-id/{tenantId}',
      getListForDropdown: 'client/agreement/location/{location}/tenant-id/{tenantId}',
      getReferralStatuses: 'client/agreement/referral-status',
      getAgreementPackages: 'client/agreement/{id}/packages',
      allowPackages: 'client/agreement/allow-packages/location/{location}/tenant-id/{tenantId}',
      fileBase: 'client/agreement/{id}/files/{name}/tenant-id/{tenantId}',
      upload: 'client/agreement/{id}/upload/tenant-id/{tenantId}',
      updatePrintOption: 'client/agreement/print-option',
      charges: {
        getAvailableUnit: 'client/agreement/{id}/units-available',
        base: 'client/agreement/{id}/charges',
        update: 'client/agreement/charges',
        delete: 'client/agreement/charges/{id}',
        getServices: 'client/agreement/charges/services/location/{location}/tenantId/{tenantId}'
      },
      getChargeHistory: 'client/agreement/{id}/charge-history',
      getAuditHistory: 'client/agreement/{id}/audit-history',
      resourceAllowances: {
        get: 'client/resource-allowance/location/{location}/tenant-id/{tenantId}',
        insert: 'client/resource-allowance/location/{location}/tenant-id/{tenantId}',
        update: 'client/resource-allowance/location/{location}/tenant-id/{tenantId}',
        delete: 'client/resource-allowance/location/{location}/tenant-id/{tenantId}/space-type-id/{spaceTypeId}'
      }
    },
    autocompleteList: 'client/autocomplete-list/location/{location}?isActive={isActive}',
    contact: {
      get: 'client/contact/location/{location}/tenant-id/{tenantId}',
      set: 'client/contact/location/{location}/tenant-id/{tenantId}',
      defaults: 'client/contact/location/{location}/defaults',
    },
    discountOverrides: {
      read: 'client/discount-overrides/location/{location}/tenant-id/{tenantId}/service-id/{serviceId}',
      create: 'client/discount-overrides',
      update: 'client/discount-overrides',
      destroy: 'client/discount-overrides/location/{location}/tenant-id/{tenantId}/service-id/{serviceId}/service-level/{serviceLevel}'
    },
    emailBlast: {
      getUsersToEmail: 'client/email-blast/location/{location}/tenant-type/{tenantType}'
    },
    collectionsReminders: {
      getPseqs: 'client/collections-reminders/location/{location}/tenant-type/{tenantType}/include/{include}'
    },
    home: {
      generalInfo: {
        base: 'client/general-info',
        get: 'client/general-info/location/{location}/tenant-id/{tenantId}',
        remove: 'client/general-info/location/{location}/tenant-id/{tenantId}'
      },
      billingPreferences: {
        base: 'client/billing-preferences/location/{location}/tenant-id/{tenantId}'
      },
      checklist: {
        get: 'client/checklist/tenant-id/{tenantId}/location/{location}/checklist-type/{checklistType}',
        update: 'client/checklist/'
      },
    },
    lateChargeOverride: {
      get: 'client/late-charge-override/location/{location}/tenant-id/{tenantId}',
      set: 'client/late-charge-override/location/{location}/tenant-id/{tenantId}',
    },
    lateCharges: {
      getInfo: 'late-charge/info/location/{location}',
      get: 'late-charge/location/{location}/date/{date}',
      post: 'late-charge'
    },
    list: 'client/list/location/{location}',
    notes: {
      getCategories: 'client/notes/categories',
      create: 'client/notes',
      read: 'client/notes/location/{location}/tenant-id/{tenantId}/category/{category}',
      update: 'client/notes',
      destroy: 'client/notes/{id}',
    },
    people: {
      add: 'client/people',
      businessInformation: 'client/people/{id}/business-information',
      clientPortalInformation: 'client/people/{id}/client-portal-information',
      getListForDropdown: 'client/people/location/{location}/tenant-id/{tenantId}',
      remove: 'client/people/{id}',
      paymentSettings: {
        autoPay: 'client/people/{pseq}/auto-pay',
        creditCard: 'client/people/{pseq}/payment-settings/credit-card',
        check: 'client/people/{pseq}/payment-settings/check'
      },
      personalInformation: 'client/people/{id}/personal-information',
      pins: {
        assign: 'client/people/pins/assign',
        create: 'client/people/pins',
        read: 'client/people/pins/location/{location}/tenant-id/{tenantId}/pseq/{pseq}',
        update: 'client/people/pins',
        destroy: 'client/people/pins/pin-id/{pinId}/pin-seq/{pinSeq}'
      },
      wifiInformation: 'client/people/{id}/wifi-information'
    },
    portal: {
      landing: 'client/portal/settings/location/{location}'
    },
    proposalInformation: {
      remove: 'client/proposal-information/{id}',
      base: 'client/proposal-information/location/{location}/tenant-id/{tenantId}'
    },
    rateOverrides: {
      base: 'client/rate-overrides',
      delete: 'client/rate-overrides/location/{location}/tenant-id/{tenantId}/service-id/{serviceId}',
      get: 'client/rate-overrides/location/{location}/tenant-id/{tenantId}',
    },
    renewalNotifications: 'client/renewal-notifications/location/{location}/tenant-type/{tenantType}/advanceDays/{advanceDays}',
    marketingOverrides: {
      base: 'client/marketing-overrides/',
      categories: 'client/marketing-overrides/location/{location}/tenant-id/{tenantId}',
      overrides: 'client/marketing-overrides/location/{location}/tenant-id/{tenantId}/category-id/{categoryId}'
    },
    network: {
      spaces: 'client/network/spaces/location/{location}/tenant-id/{tenantId}',
      bandwidthOptions: 'client/network/bandwidth-options',
      bandwidth: 'client/network/bandwidth'
    },
    paymentTerms: 'client/payment-terms',
    industryTypes: 'client/industry-types',
    mailInstructions: 'client/mail-instructions',
    invoiceGroups: 'client/invoice-groups/location/{location}',
    masterClients: 'client/master-clients',
    wifiEnabled: 'client/wifi-enabled/location/{location}/tenant-id/{tenantId}',
    futureClient: 'client/future-client/location/{location}/tenant-id/{tenantId}'
  },
  clients: 'tenants/{location}?ignoreStatus={ignoreStatus}',
  contactUs: 'contact-us',
  contexts: 'context',
  dailyActivity: {
    get: 'daily-activity?location={location}&unit={unit}&service={service}&date={date}&userId={userId}',
    insert: 'daily-activity',
    update: 'daily-activity',
    delete: 'daily-activity/{id}',
    services: 'daily-activity/services/{location}',
    restrictToThisUser: 'daily-activity/restrict'
  },
  dashboard: {
    delete: 'dashboard/{component}',
    get: 'dashboard',
    menu: 'dashboard/menu',
    put: 'dashboard',
    sort: 'dashboard/sort',
    categoryTrend: {
      line: 'dashboard/category-trend/location/{location}/category/{category}',
      donut: 'dashboard/category-trend/location/{location}'
    },
    fixedCharges: {
      category: 'dashboard/fixed-charges/category/location/{location}'
    },
    meetingRooms: {
      utilization: 'dashboard/meeting-rooms/utilization/location/{location}'
    }
  },
  email: {
    get: 'email-queue/email/{emailId}',
    save: 'email-queue/email',
    getNumberOfDrafts: 'email-generator/drafts/location/{location}/type/{type}',
    getTemplates: 'email-templates/{type}',
    createDrafts: 'email-generator/location/{location}',
    drafts: {
      get: 'email-queue/drafts/location/{location}/type/{type}',
      discard: 'email-queue/drafts/location/{location}/type/{type}',
      finalize: 'email-queue/drafts'
    }
  },
  floorPlan: {
    get: 'floor-plan/location/{location}/name/{name}',
    delete: 'floor-plan/location/{location}/name/{name}',
    uploadImage: 'floor-plan/upload-image/location/{location}/name/{name}',
    updateCoordinates: 'floor-plan/coordinates',
    getCoordinates: 'floor-plan/location/{location}/name/{name}/unit/{unit}/coordinates',
    getLocationCoordinates: 'floor-plan/location/{location}/name/{name}/coordinates',
    getNames: 'floor-plan/location/{location}/names'
  },
  geography: {
    getStates: 'geography/states',
    getCountries: 'geography/countries'
  },
  googleApi: {
    calendar: {
      insertAuthToken: 'google-api/calendar/auth-token',
      insertSelectedCalendar: 'google-api/calendar/selected',
      getList: 'google-api/calendar/list'
    }
  },
  guestPass: {
    get: 'guest-passes/location/{location}/date/{date}',
    redeem: 'guest-passes/redeem'
  },
  helpVideo: {
    base: 'help-video',
    getByName: 'help-video/{name}',
    delete: 'help-video/{id}'
  },
  imageUpload: {
    upload: 'images/location/{location}/unit/{unit}',
    getSlideshowImages: 'images/slideshow/location/{location}/',
    updateSlideshowImages: 'images/slideshow',
  },
  invoice: {
    billingDetail: {
      callData: 'invoice/billing-detail/call-data/tenant-id/{tenantId}/location/{location}/cutoff/{cutoff}',
      resource: 'invoice/billing-detail/resource/tenant-id/{tenantId}/location/{location}/cutoff/{cutoff}',
      fedex: 'invoice/billing-detail/fedex/tenant-id/{tenantId}/location/{location}/cutoff/{cutoff}',
      copies: 'invoice/billing-detail/copies/tenant-id/{tenantId}/location/{location}/cutoff/{cutoff}',
      ccp: 'invoice/billing-detail/ccp/tenant-id/{tenantId}/location/{location}/cutoff/{cutoff}',
      serviceAgreement: 'invoice/billing-detail/service-agreement/tenant-id/{tenantId}/location/{location}/cutoff/{cutoff}',
      compare: 'invoice/billing-detail/compare/tenant-id/{tenantId}/location/{location}',
      comparePreliminary: 'invoice/billing-detail/compare/preliminary/tenant-id/{tenantId}/location/{location}/category/{category}',
      compareActual: 'invoice/billing-detail/compare/actual/tenant-id/{tenantId}/location/{location}/category/{category}',
    },
    processing: {
      cutoffDate: 'invoice/cutoff',
      getInfo: 'invoice/processing/info/location/{location}',
      submit: 'invoice/processing/submit',
      processedInvoices: 'invoice/processing/processed-invoices/location/{location}',
      finalizeInvoices: 'invoice/processing/finalize-invoices/location/{location}',
      discardInvoices: 'invoice/processing/discard-invoices/location/{location}',
      downloadProcessing: 'invoice/processing/download',
      downloadFinalized: 'invoice/finalized/download'
    },
    void: {
      getInfo: 'invoice/void/info/location/{location}',
      invoices: 'invoice/void/invoices/location/{location}',
      submit: 'invoice/void/submit'
    }
  },
  invoiceDelivery: {
    getRecipients: 'invoice-delivery/recipients/location/{location}',
    getLocationMetadata: 'invoice-delivery/metadata/{location}'
  },
  invoiceDetail: {
    get: 'invoice-detail/location/{location}/tenant-id/{tenantId}/id/{id}'
  },
  payments: {
    gateway: 'payments/gateway',
    change: {
      hasPendingClose: 'payments/change/pending-close',
      payments: 'payments/change/location/{location}',
      submit: 'payments/change'
    },
    depositSlip: {
      totals: 'payments/deposit-slips/totals/location/{location}',
      get: 'payments/deposit-slips/location/{location}',
      add: 'payments/deposit-slips',
      update: 'payments/deposit-slips',
      remove: 'payments/deposit-slips/{id}',
      post: 'payments/deposit-slips/post',
      getClients: 'payments/deposit-slips/clients/location/{location}',
      getTransactionTypes: 'payments/deposit-slips/transaction-types'
    },
    eftPending: {
      get: 'payments/eft-pending/location/{location}',
      update: 'payments/eft-pending/location/{location}/transaction-number/{transactionNumber}',
      destroy: 'payments/eft-pending/location/{location}/transaction-number/{transactionNumber}'
    },
    eftReview: 'payments/eft-review/location/{location}/from-date/{fromDate}/to-date/{toDate}',
    hasPendingClose: 'payments/pending-close',
    eftProcessing: {
      base: 'payments/eft-processing/location/{location}',
      update: 'payments/eft-processing',
      transmit: 'payments/eft-processing/transmit/location/{location}',
      syncPlacePay: 'payments/eft-processing/sync-place-pay'
    }
  },
  locationAllowance: {
    getList: 'location-allowance/location/{location}',
    update: 'location-allowance',
    insert: 'location-allowance',
    delete: 'location-allowance/location/{location}?clientType={clientType}&serviceId={serviceId}'
  },
  locations: {
    ccws: 'locations/ccws/{includeAll}',
    standard: 'locations/{includeAll}',
    scheduler: 'scheduler/locations'
  },
  login: {
    forgotPassword: 'account/forgot-password',
    login: 'account/login',
    tokenLogin: 'account/token-login',
    resetPassword: 'account/reset-password'
  },
  maintenance: 'system-variables/maintenance',
  menu: {
    get: 'menu/{userId}',
    getBySecurityGroup: 'menu/security-group/{securityGroupId}',
    updateRouteOverride: 'menu/update-override'
  },
  monthlyInvoices: {
    get: 'monthly-invoices/period/{period}/location/{location}?includeStatements={includeStatements}'
  },
  officeAddOns: {
    getList: 'office-add-ons/{planServiceId}',
    save: 'office-add-ons',
    delete: 'office-add-ons/{planServiceId}/{addOnServiceId}'
  },
  package: {
    get: 'packages'
  },
  periods: 'periods',
  pins: 'pins',
  profileUpload: {
    get: 'profile-upload',
    delete: 'profile-upload/{id}',
    saveFile: 'profile-upload/{profileId}/location/{location}',
    getHistory: 'profile-upload/history',
    assignReject: 'profile-upload/assign-reject',
    getRejects: 'profile-upload/rejects/{id}',
    deleteHistory: 'profile-upload/history/{id}'
  },
  reports: {
    agingOptions: 'reports/aging-options',
    download: 'reports/download/{format}',
    queryString: 'reports/query-string?queryString={queryString}'
  },
  securityGroup: 'security-group/user',
  serviceGroupSettings: {
    getServiceGroups: 'settings/service-groups',
    saveServiceGroup: 'settings/service-groups',
    deleteServiceGroup: 'settings/service-groups/{id}',
    getServiceGroupDetails: 'settings/service-groups/details/{serviceGroupId}',
    saveServiceGroupDetails: 'settings/service-groups/details',
    deleteServiceGroupDetail: 'settings/service-groups/details/{serviceGroupId}?serviceId={serviceId}&packageId={packageId}',
    excludedLocationList: 'settings/service-groups/excluded-locations/group/{groupId}/service/{serviceId}',
    updateExcludedLocation: 'settings/service-groups/excluded-locations',
    insertPackageDetail: 'settings/service-groups/package-details',
    deletePackageDetail: 'settings/service-groups/package-details/{id}',
    getPackageDetails: 'settings/service-groups/package-details/group/{groupId}/package/{packageId}',
    deleteAddOnOverride: 'settings/service-groups/add-on-overrides/location/{location}/service/{serviceId}/add-on-service/{addOnServiceId}',
    insertAddOnOverride: 'settings/service-groups/add-on-overrides',
    getAddOnOverrideList: 'settings/service-groups/add-on-overrides/location/{location}/service/{serviceId}',
    deleteAddOn: 'settings/service-groups/add-ons/service/{serviceId}/add-on-service/{addOnServiceId}/context/{context}',
    insertAddOn: 'settings/service-groups/add-ons',
    getAddOnList: 'settings/service-groups/add-ons/service/{serviceId}',
    getFeaturesList: 'virtual-feature-list/group/{groupId}/service/{serviceId}',
    deleteFeature: 'virtual-feature-list/group/{groupId}/service/{serviceId}/id/{fseq}',
    insertFeature: 'virtual-feature-list'
  },
  services: {
    clientTypeOverrides: 'services/client-type-overrides/{tenantId}',
    forDropdown: 'services/for-dropdown',
    forDropdownByClass: 'services/for-dropdown/classes/{classList}',
    locationOverrides: 'services/location-overrides/{location}',
    ratesAndMarkups: 'services/rates-and-markups'
  },
  serviceUpgrades: {
    getServiceGroupUpgrades: 'settings/service-groups/upgrades/service/{baseServiceId}',
    saveServiceGroupUpgrades: 'settings/service-groups/upgrades',
    deleteServiceGroupUpgrades: 'settings/service-groups/upgrades/service/{baseServiceId}/upgrade/{upgradeServiceId}'
  },
  settings: {
    client: {
      clientTypes: {
        getTypes: 'settings/client/tenant-type',
        add: 'settings/client/tenant-type',
        update: 'settings/client/tenant-type',
        delete: 'settings/client/tenant-type/{id}'
      },
      noteCategories: {
        add: 'settings/client/note-categories',
        update: 'settings/client/note-categories',
        delete: 'settings/client/note-categories/{id}',
      },
      packages: {
        getPackages: 'settings/client/packages',
        addPackage: 'settings/client/packages',
        updatePackage: 'settings/client/packages',
        deletePackage: 'settings/client/packages/{packageId}',
        getDetails: 'settings/client/packages/{id}/details',
        addDetail: 'settings/client/packages/details',
        updateDetail: 'settings/client/packages/details',
        deleteDetail: 'settings/client/packages/details/{id}'
      }
    },
    scheduler: {
      meetingRooms: {
        availableUnits: 'settings/scheduler/available-units/location/{location}',
        createRoom: 'settings/scheduler/meeting-room',
        deleteRoom: 'settings/scheduler/meeting-room/location/{location}/unit/{unit}',
        rooms: 'settings/scheduler/meeting-room/location/{location}',
        getGeneral: 'settings/scheduler/meeting-room/general/location/{location}/unit/{unit}',
        updateGeneral: 'settings/scheduler/meeting-room/general',
        getImage: 'settings/scheduler/meeting-room/image/location/{location}/unit/{unit}',
        getBilling: 'settings/scheduler/meeting-room/billing/location/{location}/unit/{unit}',
        updateBilling: 'settings/scheduler/meeting-room/billing',
        getCancellation: 'settings/scheduler/meeting-room/cancellation/location/{location}/unit/{unit}',
        updateCancellation: 'settings/scheduler/meeting-room/cancellation',
        getAmenities: 'settings/scheduler/meeting-room/amenities/location/{location}/unit/{unit}',
        updateAmenities: 'settings/scheduler/meeting-room/amenities',
        getBlockList: 'settings/scheduler/meeting-room/blocked/location/{location}/unit/{unit}',
        updateBlockList: 'settings/scheduler/meeting-room/blocked',
        getBillingMaxList: 'settings/scheduler/meeting-room/billing-max/location/{location}/unit/{unit}',
        addBillingMaxItem: 'settings/scheduler/meeting-room/billing-max',
        removeBillingMaxItem: 'settings/scheduler/meeting-room/billing-max/location/{location}/unit/{unit}/tenant-type/{tenantType}',
        getBinPromoList: 'settings/scheduler/meeting-room/bin-promo/location/{location}/unit/{unit}',
        addBinPromoItem: 'settings/scheduler/meeting-room/bin-promo',
        removeBinPromoItem: 'settings/scheduler/meeting-room/bin-promo/location/{location}/unit/{unit}/promo-code/{promoCode}',
        getScheduling: 'settings/scheduler/meeting-room/scheduling/location/{location}/unit/{unit}',
        updateScheduling: 'settings/scheduler/meeting-room/scheduling'
      }
    },
    system: {
      transactions: {
        get: 'settings/system/transactions',
        add: 'settings/system/transactions',
        update: 'settings/system/transactions',
        delete: 'settings/system/transactions/code/{code}',
        glAccounts: 'settings/system/transactions/accounts',
        depositRetainerTypes: 'settings/system/transactions/types'
      },
      services: {
        getServices: 'settings/system/services',
        getDetails: 'settings/system/services/{id}/details',
        addDetails: 'settings/system/services/details',
        updateDetails: 'settings/system/services/details',
        deleteService: 'settings/system/services/{id}',
        getDiscounts: 'settings/system/services/{id}/discounts',
        updateDiscounts: 'settings/system/services/{id}/discounts',
        getTaxes: 'settings/system/services/location/{location}/service/{id}/taxes',
        getTaxCategories: 'settings/system/services/location/{location}/tax-categories',
        updateTaxes: 'settings/system/services/location/{location}/service/{id}/taxes',
        getExtensions: 'settings/system/services/{id}/extensions',
        updateExtensions: 'settings/system/services/extensions'
      },
      clientTypeOverrides: {
        getClientTypeOverrides: 'settings/system/client-type-overrides/location/{location}',
        addClientTypeOverrides: 'settings/system/client-type-overrides/location/{location}',
        updateClientTypeOverrides: 'settings/system/client-type-overrides/location/{location}',
        deleteClientTypeOverride: 'settings/system/client-type-overrides/location/{location}/client-type/{clientType}/service/{serviceId}'
      },
      roles: {
        getRoles: 'settings/system/roles',
        saveRoles: 'settings/system/roles',
        deleteRole: 'settings/system/roles/{id}'
      }
    },
    location: {
      roles: {
        getRoles: 'settings/location/{location}/roles',
        saveRoles: 'settings/location/{location}/roles',
        deleteRole: 'settings/location/{location}/role/{roleId}/user/{userId}'
      },
      address: {
        getAddress: 'settings/location/{location}/address',
        saveAddress: 'settings/location/{location}/address',
        markets: 'settings/markets',
        timeZones: 'settings/time-zones'
      },
      wifi: {
        getWiFi: 'settings/location/{location}/wifi',
        saveWiFi: 'settings/location/{location}/wifi'
      }
    }
  },
  scheduler: {
    getLocationMetadata: 'scheduler/location-metadata/{location}',
    testAvailability: 'scheduler/test-availability?location={location}&unit={unit}&startTime={startTime}&endTime={endTime}&scid={scid}',
    getMeetingList: 'scheduler/meeting?location={location}&date={date}&numberOfDays={numberOfDays}',
    getMeetingPrice: 'scheduler/{id}/price',
    chargeMeeting: 'creditcard/pay',
    updateMeeting: 'scheduler/meeting',
    insertMeeting: 'scheduler/meeting',
    cancelMeeting: 'scheduler/meeting/cancel',
    operationsReview: {
      getMeetings: 'scheduler/operations-review/start-date/{startDate}/end-date/{endDate}/location/{location}/reviewed/{reviewed}',
      getMeetingActuals: 'scheduler/operations-review/meeting-actual/scid/{scid}',
      saveMeetingActuals: 'scheduler/operations-review/meeting-actual',
      saveCancellationOverride: 'scheduler/operations-review/cancellation-override',
      getMeetingCharges: 'scheduler/{scid}/operations-review/meeting-charges',
      base: 'scheduler/operations-review/meeting-charges'
    }
  },
  schedulerSettings: {
    spaceTypes: {
      getList: 'scheduler-settings/unit-types',
      insert: 'scheduler-settings/unit-types',
      update: 'scheduler-settings/unit-types',
      delete: 'scheduler-settings/unit-types/{id}',
    },
    spaces: {
      getList: 'scheduler-settings/spaces/{location}',
      insert: 'scheduler-settings/spaces/{location}',
      update: 'scheduler-settings/spaces/{location}',
      delete: 'scheduler-settings/spaces/{location}/{id}',
      userFields: 'scheduler-settings/spaces/user-fields'
    },
    utilization: {
      getData: 'scheduler-settings/utilization/start-date/{startDate}/end-date/{endDate}'
    }
  },
  systemVariables: {
    maintenance: 'system-variables/maintenance'
  },
  tenantPeople: {
    schedulerContacts: 'tenant-people/scheduler/location/{location}'
  },
  tenantPeopleVariableDetail: {
    getByLocation: 'tenant-people-variables/type/{type}/location/{location}',
    redeem: 'tenant-people-variables'
  },
  tenantTypes: 'tenant-type',
  tierPricing: {
    base: 'sign-up-now/tier-pricing',
    delete: 'sign-up-now/tier-pricing/{id}'
  },
  serviceGroupPackageDetail: {
    getAll: 'sign-up-now/service-group-package-detail/all',
    getList: 'sign-up-now/service-group-package-detail/package/{packageId}/serviceGroup/{serviceGroupId}',
    save: 'sign-up-now/service-group-package-detail/save'
  },
  tiers: 'tier',
  transactionCode: {
    get: 'transaction-code/{includeAll}'
  },
  units: {
    all: 'units/location/{location}',
    meetingRooms: 'units/meeting-rooms/location/{location}',
    unitsForDailyActivityByLocation: 'units/location/{location}/client/{client}'
  },
  unitTypes: {
    all: 'unit-types',
    meetingRooms: 'unit-types/meeting-rooms'
  },
  userCategory: {
    get: 'reports/user-categories',
    set: 'reports/user-categories'
  },
  userLocation: {
    get: 'reports/user-locations',
    set: 'reports/user-locations'
  },
  userTransactionCode: {
    get: 'reports/user-transaction-codes',
    set: 'reports/user-transaction-codes'
  },
  webUsers: {
    webUsers: 'web-users/',
    webUsersByLocation: 'web-users/location/{location}',
    updateDefaultLocation: 'web-users/location',
    userInfo: 'web-users/info',
    emails: 'web-users/emails'
  },
  fedex: {
    lastBatchKey: 'fedex-upload/lastBatchKey',
    importFedex: 'fedex-upload/import',
    deleteFedex: 'fedex-upload/delete/{batchKey}'
  },
  virtualInformation: {
    Agreement: 'virtual/agreement/location/{location}/tenantId/{tenantId}',
    AgreementPromotionDetails: 'virtual/agreement-promo-details/agreement/{agreement}',
    AgreementBillingSchedule: 'virtual/billing-schedule/agreement/{agreement}',
    VirtualSessionHistory: 'virtual/session-history/location/{location}/dateStart/{start}/dateEnd/{end}'
  },
  shipment: {
    unassignedShipments: 'shipment/unassigned/location/{location}',
    details: 'shipment/detail/shipment/{shipmentId}',
    assign: 'shipment/assign'
  },
  systemParameters: 'system-parameters',
  prospects: {
    proposal: {
      createInfo: 'proposals/create-info/location/{location}/tenant-id/{tenantId}',
      info: 'proposals/info/{agreementId}',
      checkProposal: 'proposals/check/{agreementId}',
      proposal: 'proposals',
      saveRecipients: 'proposals/recipients',
      previewProposal: 'proposals/preview/{agreementId}',
      sendProposal: 'proposals/send'
    }
  }
};
